import jwtDecode from "jwt-decode";
import http from "./httpService";
import { jwt as jwtHelpers } from "../helpers";
import { AuthService, MarketService } from ".";

const apiEndpoint = process.env.REACT_APP_API_IDENTITY_URL + "/auth";
const accessApiEndPoint = process.env.REACT_APP_API_IDENTITY_URL + "/common/pageaccess";
const tokenKey = "token";
const userIdKey = "user_id";
const userKey = "user";
const marketIdKey = "market_id";
const marketNameKey = "market_name";
const marketKey = "market";
const groupNameKey = "group_name";
const groupIdKey = "group_id";
const filtersKey = "dashboard_filters";
const contentLibraryFiltersKey = "content_library_filters";

http.setJwt(getJwt());

export async function login(data) {
  return await http.post(apiEndpoint + "/login", data);
}

export function setSession(data) {
  try {
    if (localStorage.getItem(tokenKey) !== null) {
      localStorage.removeItem(tokenKey);
    }

    localStorage.setItem(tokenKey, data.access_token);

    if (localStorage.getItem(userIdKey) !== null) {
      localStorage.removeItem(userIdKey);
    }

    localStorage.setItem(userIdKey, data.user_id);

    if (localStorage.getItem(marketKey) !== null) {
      localStorage.removeItem(marketKey);
    }

    if (data.market !== null) {
      localStorage.setItem(marketKey, JSON.stringify(data.market));
    }

    if (localStorage.getItem(marketIdKey) !== null) {
      localStorage.removeItem(marketIdKey);
    }

    if (data.market !== null) {
      localStorage.setItem(marketIdKey, data.market.id);
    }

    if (localStorage.getItem(marketNameKey) !== null) {
      localStorage.removeItem(marketNameKey);
    }

    if (data.market !== null) {
      localStorage.setItem(marketNameKey, data.market.name);
    }

    if (localStorage.getItem(groupNameKey) !== null) {
      localStorage.removeItem(groupNameKey);
    }
    localStorage.setItem(groupNameKey, data.group_name);

  } catch (ex) {
  }
}

export function removeSession() {
  removeToken();
  removeUserId();
  removeMarketId();
}

export function loginWithJwt(jwt) {
  localStorage.setItem(tokenKey, jwt);
}

export async function logout() {
  http.setJwt(getJwt());
  localStorage.clear();
  return await http.post(apiEndpoint + "/logout");
}

export function getCurrentUser() {
  try {
    if (localStorage.getItem(tokenKey) !== null) {
      const jwt = localStorage.getItem(tokenKey);
      return jwtDecode(jwt);
    }

    return null;
  } catch (ex) {
    return null;
  }
}

export function getUserId() {
  try {
    if (localStorage.getItem(tokenKey) !== null) {
      const jwt = localStorage.getItem(tokenKey);
      const jwtDecoded = jwtDecode(jwt);
      let userValue = jwtHelpers.getValue(jwtDecoded, userIdKey);
      return userValue;
    }
    return false;
  } catch (ex) {
    return false;
  }
}

export function getCurrentMarketId() {
  try {
    if (localStorage.getItem(marketIdKey) !== null) {
      const market = localStorage.getItem(marketIdKey);
      return market;
    }

    return null;
  } catch (ex) {
    return null;
  }
}

export function getCurrentMarket() {
  try {

    if (localStorage.getItem(marketKey) !== null) {
      var market = localStorage.getItem(marketKey);
      return JSON.parse(market);
    }

    return null;
  } catch (ex) {
    return null;
  }
}

export function getCurrentMarketName() {
  try {

    if (localStorage.getItem(marketNameKey) !== null) {
      const market = localStorage.getItem(marketNameKey);
      return market;
    }

    return null;
  } catch (ex) {
    return null;
  }
}

export function getCurrentMarketCode() {
  try {
    if (localStorage.getItem(marketKey) !== null) {
      const market = localStorage.getItem(marketKey);
      return market;
    }

    return null;
  } catch (ex) {
    return null;
  }
}

export function getMarketId() {
  try {
    if (localStorage.getItem(tokenKey) !== null) {
      const jwt = localStorage.getItem(tokenKey);
      const jwtDecoded = jwtDecode(jwt);

      let roleValue = jwtHelpers.getValue(jwtDecoded, "market_id");
      return roleValue;
    }
    return false;
  } catch (ex) {
    return false;
  }
}
export function getUserGroupId() {
  return localStorage.getItem(groupIdKey);
}

export function getRole() {
  try {
    if (localStorage.getItem(tokenKey) !== null) {
      const jwt = localStorage.getItem(tokenKey);
      const jwtDecoded = jwtDecode(jwt);
      let role = jwtHelpers.getValue(jwtDecoded, "role");
      return role;
    }
    return "";
  } catch (ex) {
    return "";;
  }
}

export function isRole(role) {
  try {
    if (localStorage.getItem(tokenKey) !== null) {
      const jwt = localStorage.getItem(tokenKey);
      const jwtDecoded = jwtDecode(jwt);
      let roleValue = jwtHelpers.getValue(jwtDecoded, "role");
      return roleValue === role ? true : false;
    }
    return false;
  } catch (ex) {
    return false;
  }
}

export function isSuperAdmin() {
  try {
    if (localStorage.getItem(tokenKey) !== null) {
      const jwt = localStorage.getItem(tokenKey);
      const jwtDecoded = jwtDecode(jwt);
      let role = jwtHelpers.getValue(jwtDecoded, "role");
      return role === "Super Admin" ? true : false;
    }
    return false;
  } catch (ex) {
    return false;
  }
}

export function isAdmin() {
  try {
    if (localStorage.getItem(tokenKey) !== null) {
      const jwt = localStorage.getItem(tokenKey);
      const jwtDecoded = jwtDecode(jwt);
      let role = jwtHelpers.getValue(jwtDecoded, "role");
      return role === "Admin" ? true : false;
    }
    return false;
  } catch (ex) {
    return false;
  }
}

export function isUser() {
  try {
    if (localStorage.getItem(tokenKey) !== null) {
      const jwt = localStorage.getItem(tokenKey);
      const jwtDecoded = jwtDecode(jwt);
      let role = jwtHelpers.getValue(jwtDecoded, "role");
      return role === "User" ? true : false;
    }
    return false;
  } catch (ex) {
    return false;
  }
}

export function isVendorTeamLead() {
  try {
    if (localStorage.getItem(tokenKey) !== null) {
      const jwt = localStorage.getItem(tokenKey);
      const jwtDecoded = jwtDecode(jwt);
      let role = jwtHelpers.getValue(jwtDecoded, "role");
      return role === "Vendor Team Lead" ? true : false;
    }
    return false;
  } catch (ex) {
    return false;
  }
}

export function isVendorAdmin() {
  try {
    if (localStorage.getItem(tokenKey) !== null) {
      const jwt = localStorage.getItem(tokenKey);
      const jwtDecoded = jwtDecode(jwt);
      let role = jwtHelpers.getValue(jwtDecoded, "role");
      return role === "Vendor Admin" ? true : false;
    }
    return false;
  } catch (ex) {
    return false;
  }
}

export function isVendorUser() {
  try {
    if (localStorage.getItem(tokenKey) !== null) {
      const jwt = localStorage.getItem(tokenKey);
      const jwtDecoded = jwtDecode(jwt);
      let role = jwtHelpers.getValue(jwtDecoded, "role");
      return role === "Vendor User" ? true : false;
    }
    return false;
  } catch (ex) {
    return false;
  }
}
export async function hasAccess(screen) {
  try {
    let response = await MarketService.GetMarkets(AuthService.getUserId())
    let market_ids = response.data.Data.map((item) => {
      return item.id
    })
    let request = { screen, market_ids }
    http.setJwt(getJwt());
    return await http.post(accessApiEndPoint, request);
  } catch (ex) {
    return false;
  }
}

export function getJwt() {
  return localStorage.getItem(tokenKey);
}

export function setJwt(token) {
  http.setJwt(getJwt());
  return localStorage.setItem(tokenKey, token);
}

export function removeAll() {
  removeToken();
  removeUser();
  removeMarket();
  removeFilters();
  removeContentLibraryFilters();
  removeGroupName();
}

export function removeToken() {
  localStorage.removeItem(tokenKey);
}

export function removeUserId() {
  localStorage.removeItem(userIdKey);
}

export function removeUser() {
  localStorage.removeItem(userKey);
}

export function removeMarketId() {
  localStorage.removeItem(marketIdKey);
}

export function removeMarket() {
  localStorage.removeItem(marketKey);
}

export function removeFilters() {
  localStorage.removeItem(filtersKey);
}

export function removeContentLibraryFilters() {
  localStorage.removeItem(contentLibraryFiltersKey);
}

export function removeGroupName() {
  localStorage.removeItem(groupNameKey);
}

export function removeContentOutputSession() {
  localStorage.removeItem("content_output");
}

export function isBankPartner() {
  try {
    const groupName = localStorage.getItem(groupNameKey);
    if (groupName !== null) {
      return groupName === "BP" ? true : false;
    }
    return false;
  } catch (ex) {
    return false;
  }
}

export function isF2F() {
  try {
    const groupName = localStorage.getItem(groupNameKey);
    if (groupName !== null) {
      return (groupName === "null" || groupName === "F2F") ? true : false;
    }
    return false;
  } catch (ex) {
    return false;
  }
}

export function isESA() {
  try {
    const groupName = localStorage.getItem(groupNameKey);
    if (groupName !== null) {
      return groupName === "ESA" ? true : false;
    }
    return false;
  } catch (ex) {
    return false;
  }
}

export function isGroupNull() {
  const groupName = localStorage.getItem(groupNameKey);
  if (groupName === null) {
    return true;
  }
  return false;
}

export default {
  login,
  setSession,
  removeSession,
  loginWithJwt,
  logout,
  getCurrentUser,
  getUserId,
  getCurrentMarket,
  getCurrentMarketName,
  getCurrentMarketId,
  getCurrentMarketCode,
  getMarketId,
  getUserGroupId,
  getRole,
  isRole,
  isSuperAdmin,
  isVendorTeamLead,
  isVendorAdmin,
  isVendorUser,
  isAdmin,
  isUser,
  getJwt,
  removeAll,
  removeToken,
  removeUser,
  removeMarket,
  isBankPartner,
  isF2F,
  isESA,
  isGroupNull,
  hasAccess
};
